import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Modal from 'react-bootstrap/lib/Modal';
import classnames from 'classnames';
import moment from 'moment';
import i18n from 'i18next';

import {AGE_CONSENT_META_DATA_BIRTHDAY, AGE_CONSENT_TYPE, AGE_CONSENT_META_DATA_PARENTAL, AGE_CONSENT_FULL_AGE_LIMIT, SENSITIVE_DATA_CONSENT_TYPE, TOS_CONSENT_TYPE, PRIVACY_CONSENT_TYPE, DATA_NOTICE} from '../common'

import Checkbox from './Checkbox';
import Select from './Select';
import ConsentService from './ConsentService';

import './index.less';
import SanityBlockContent from '@sanity/block-content-to-react';
import FeatureAvailableService from '../FeatureAvailableService';

const BlockContent = (props) => <SanityBlockContent {...props} />;
BlockContent.displayName = 'BlockContent';
BlockContent.defaultSerializers = SanityBlockContent.defaultSerializers;

class ConsentModal extends React.Component {
    static displayName = 'Layout.Flow.ConsentModal';
    static propTypes = {
        t: PropTypes.func,
        applicationName: PropTypes.string
    };
    static defaultProps = {
        applicationName: null
    };

    constructor(props) {
        super(props);

        this.legalTextRefs = {};

        this.state = {
            isConsentsAccepted: null,
            userConsents: null,
            ageDay: null,
            ageMonth: null,
            ageYear: null,
            isParentalAcceptance: null,
            ssoEnabled: false
        };
    }

    getIsSsoEnabled = async () => {
        const ssoEnabled = await FeatureAvailableService.isSsoEnabled();
        this.setState({ssoEnabled: ssoEnabled});
    }

    componentWillMount() {
        const ssoEnabled = this.getIsSsoEnabled();
        
        ConsentService.getUserConsents(this.props.applicationName, i18n.language).then(userConsents => {
            if (userConsents) {
                var ageConsent = userConsents.filter(consent => consent.type === AGE_CONSENT_TYPE);
                if (ageConsent.length > 0) {
                    var ageDay = null;
                    var ageMonth = null;
                    var ageYear = null;
                    var birthdayMetaData = ageConsent[0].metaData.filter(metaData => metaData.description === AGE_CONSENT_META_DATA_BIRTHDAY);
                    if (birthdayMetaData && birthdayMetaData.length > 0) {
                        var birthdayText = birthdayMetaData[0] ? birthdayMetaData[0].content || null : null;
                        if (birthdayText) {
                            var birthday = moment(birthdayText).startOf('day');
                            ageDay = birthday.date().toString();
                            ageMonth = birthday.month().toString();
                            ageYear = birthday.year().toString();
                            var age;
                            if (moment(ageConsent.serverDate).isValid()) {
                                age = moment(ageConsent.serverDate).startOf('day').diff(birthday, 'years');
                            } else {
                                age = moment().utc().startOf('day').diff(birthday, 'years');
                                console.log("Server didn't provide Date header, age calculation applies user time in utc");
                            }
                            if (age < AGE_CONSENT_FULL_AGE_LIMIT) {
                                ageConsent[0].isMissingGuardianCheck = true;
                            }
                        }
                    }
                    var isParentalAcceptance = false;
                }
                this.setState({
                    userConsents,
                    ageDay,
                    ageMonth,
                    ageYear,
                    isParentalAcceptance
                });
            } else {
                this.setState({
                    userConsents: null
                });
            }
        }).catch(e => console.error('Unexpected error occurred on getting user consents', e));
    }

    flipContentVisibility = (i) => {
        var userConsents = this.state.userConsents;
        var userConsent = Object.assign({}, this.state.userConsents[i], { isContentVisible: !this.state.userConsents[i].isContentVisible });
        userConsents[i] = userConsent;
        this.setState({ userConsents });
    }

    consentsAcceptClick = () => {
        if (this.hasLegalContentErrors()) {
            this.setState({ isConsentsAccepted: false });
            return;
        }
        var userConsents = this.state.userConsents;
        for (let i = 0; i < userConsents.length; i++) {
            let userConsent = userConsents[i];
            userConsent = Object.assign({}, userConsent, { isMissingCheck: false }, { isMissingAgeSelect: false }, { isMissingGuardianCheckIcon: false });
            userConsents[i] = userConsent;
        }
        this.setState({ userConsents }, () => {
            setTimeout(() => { // Hack to handle too fast optimized rendering without class being changed
                var isAnyConsentMissingCheck = false;
                for (let i = 0; i < userConsents.length; i++) {
                    let userConsent = userConsents[i];
                    if (userConsent.type === AGE_CONSENT_TYPE) {
                        if (this.state.ageDay && this.state.ageMonth && this.state.ageYear) {
                            var birthday = moment().set('date', this.state.ageDay).set('month', this.state.ageMonth).set('year', this.state.ageYear).startOf('day');
                            var age;
                            if (moment(userConsent.serverDate).isValid()) {
                                age = moment(userConsent.serverDate).startOf('day').diff(birthday, 'years');
                            } else {
                                age = moment().utc().startOf('day').diff(birthday, 'years');
                                console.log("Server didn't provide Date header, age calculation applies user time in utc");
                            }
                            if (age < AGE_CONSENT_FULL_AGE_LIMIT && !this.state.isParentalAcceptance) {
                                userConsent.isMissingGuardianCheckIcon = true;
                                isAnyConsentMissingCheck = true;
                            }
                            else {
                                var birthdayMetaData = userConsent.metaData.filter(metaData => metaData.description === AGE_CONSENT_META_DATA_BIRTHDAY)[0];
                                var parentalMetaData = userConsent.metaData.filter(metaData => metaData.description === AGE_CONSENT_META_DATA_PARENTAL)[0];
                                if (!birthdayMetaData) {
                                    birthdayMetaData = {content: '', description: AGE_CONSENT_META_DATA_BIRTHDAY};
                                }
                                if (!parentalMetaData) {
                                    parentalMetaData = {content: '', description: AGE_CONSENT_META_DATA_PARENTAL};
                                }
                                userConsent.accepted = true;
                                birthdayMetaData.content = moment().set('date', this.state.ageDay).set('month', this.state.ageMonth).set('year', this.state.ageYear).format('YYYY-MM-DD');
                                parentalMetaData.content = this.state.isParentalAcceptance.toString();
                                userConsent.metaData[0] =  birthdayMetaData;
                                userConsent.metaData[1] =  parentalMetaData;
                            }
                        } else {
                            userConsent.isMissingAgeSelect = true;
                            isAnyConsentMissingCheck = true;
                        }
                    }
                    else if (userConsent.required && !userConsent.accepted) {
                        userConsent = Object.assign({}, userConsent, { isMissingCheck: true });
                        isAnyConsentMissingCheck = true;
                    }
                    userConsents[i] = userConsent;
                }
                this.setState({ userConsents });
                if (!isAnyConsentMissingCheck) {
                    this.setState({ isConsentsAccepted: true });
                    ConsentService.postUserConsents(userConsents).then().catch((ex) => {
                        console.error('Unexpected error occurred on saving user consents', ex);
                    });
                } else {
                    this.setState({ isConsentsAccepted: false });
                }
            }, 1);
        });
    }

    checkboxClicked = (i, checkbox) => {
        var accepted = checkbox.state.checked;
        var userConsents = this.state.userConsents;
        if (userConsents[i].type === AGE_CONSENT_TYPE) {
            var isParentalAcceptance = accepted;
            if (accepted && userConsents[i].isMissingGuardianCheckIcon) {
                userConsents[i].isMissingGuardianCheckIcon = false;
            }
            this.setState({
                userConsents,
                isParentalAcceptance
            });
        } else {
            var isMissingCheck = (!userConsents[i].isMissingCheck || !accepted) ?
                userConsents[i].isMissingCheck : !(userConsents[i].isMissingCheck && accepted); // For hiding missing warning if checked
            var userConsent = Object.assign({}, this.state.userConsents[i], { accepted }, { isMissingCheck });
            userConsents[i] = userConsent;
            this.setState({ userConsents });
        }
    }

    ageValueChanged(ageDay, ageMonth, ageYear) {
        if (ageDay && ageMonth && ageYear) {
            var ageConsent = this.state.userConsents.filter(userConsent => userConsent.type === AGE_CONSENT_TYPE)[0];
            var birthday = moment().set('date', ageDay).set('month', ageMonth).set('year', ageYear).startOf('day');
            var age;
            if (moment(ageConsent.serverDate).isValid()) {
                age = moment(ageConsent.serverDate).startOf('day').diff(birthday, 'years');
            } else {
                age = moment().utc().startOf('day').diff(birthday, 'years');
                console.log("Server didn't provide Date header, age calculation applies user time in utc");
            }
            if (ageConsent.isMissingAgeSelect) {
                ageConsent.isMissingAgeSelect = false;
            }
            if (age < AGE_CONSENT_FULL_AGE_LIMIT) {
                ageConsent.isMissingGuardianCheck = true;
            } else {
                ageConsent.isMissingGuardianCheck = false;
                ageConsent.isMissingGuardianCheckIcon = false;
            }
        }
        var userConsents = this.state.userConsents;
        this.setState({
            userConsents,
            ageDay,
            ageMonth,
            ageYear
        })
    }

    listSensitiveConsents(sensitiveList) {
        const {t} = this.props;
        const sensitiveDataList = [];

        for (const sensitiveDataItem of sensitiveList) {
            const translationKey = sensitiveDataItem.dataTypeTranslationKey.replace('gdpr.', 'gdpr:')
            sensitiveDataList.push(<li id={sensitiveDataItem.dataTypeId} key={sensitiveDataItem.dataTypeId} className='sensitive-consent-list'>{`${t(translationKey)}`}</li>)
        }

        return <ul className='consent-modal-sensitive-data-list'>{sensitiveDataList}</ul>
    }

    getLegalHeadingId(node) {
        const { style = 'normal', children = [] } = node;
        if (['h1', 'h2', 'h3', 'h4'].indexOf(style) === -1) {
            return null;
        }
        if (children[0] && children[0].text) {
            return children[0].text;
        }
        return null;
    }

    getLegalBlockId(node) {
        const { markDefs = [] } = node;
        for (let i = 0; i < markDefs.length; i++) {
            if (markDefs[i] && markDefs[i].html_id) {
                return markDefs[i].html_id;
            }
        }
        return null;
    }

    getLegalLinkMarkDef(node) {
        const { markDefs = [] } = node;
        for (let i = 0; i < markDefs.length; i++) {
            if (markDefs[i] && Object.prototype.hasOwnProperty.call(markDefs[i], 'href')) {
                return markDefs[i];
            }
        }
        return null;
    }

    renderLegalBlock = (props) => {
        const { style = 'normal' } = props.node;
        const blockId = this.getLegalBlockId(props.node);
        if (blockId && ['normal', 'h1', 'h2', 'h3', 'h4'].indexOf(style) !== -1) {
            const BlockTag = style === 'normal' ? 'p' : style;
            return <BlockTag id={blockId}>{props.children}</BlockTag>;
        }
        const headingId = this.getLegalHeadingId(props.node);
        if (headingId) {
            const HeadingTag = style;
            return <HeadingTag id={headingId}>{props.children}</HeadingTag>;
        }
        return BlockContent.defaultSerializers.types.block(props)
    }

    setLegalTextRef = (index, element) => {
        if (element) {
            this.legalTextRefs[index] = element;
        } else {
            delete this.legalTextRefs[index];
        }
    }

    normalizeLegalHash = (value) => {
        if (!value) {
            return '';
        }
        const rawHash = value.charAt(0) === '#' ? value.substring(1) : value;
        try {
            return decodeURIComponent(rawHash).trim();
        } catch (e) {
            return rawHash.trim();
        }
    }

    findLegalAnchorTarget = (container, hash) => {
        if (!container || !hash) {
            return null;
        }
        const normalizedHash = this.normalizeLegalHash(hash);
        const elementsWithId = container.querySelectorAll('[id]');
        for (let i = 0; i < elementsWithId.length; i++) {
            if (this.normalizeLegalHash(elementsWithId[i].getAttribute('id')) === normalizedHash) {
                return elementsWithId[i];
            }
        }
        if (/^toc\d+$/i.test(normalizedHash)) {
            const headingIndex = Number(normalizedHash.replace(/toc/i, '')) - 1;
            const tocLinks = container.querySelectorAll('a[href^="#toc"]');
            const tocLink = tocLinks[headingIndex];
            if (tocLink && tocLink.textContent) {
                const tocText = tocLink.textContent.trim();
                if (tocText) {
                    const headingsByText = container.querySelectorAll('h1, h2, h3, h4');
                    for (let i = 0; i < headingsByText.length; i++) {
                        if ((headingsByText[i].textContent || '').trim() === tocText) {
                            return headingsByText[i];
                        }
                    }
                }
            }
            const headings = container.querySelectorAll('h1, h2, h3, h4');
            return headings[headingIndex] || null;
        }
        return null;
    }

    updateLegalHashInUrl = (hash) => {
        if (!hash || !window || !window.history || !window.location) {
            return;
        }
        const encodedHash = encodeURIComponent(hash);
        const nextUrl = `${window.location.pathname}${window.location.search}#${encodedHash}`;
        window.history.replaceState(null, '', nextUrl);
    }

    findScrollableAncestor = (targetElement, boundaryElement) => {
        let node = targetElement;
        while (node && node !== boundaryElement) {
            if (node.scrollHeight > node.clientHeight) {
                const style = window.getComputedStyle ? window.getComputedStyle(node) : null;
                const overflowY = style ? style.overflowY : '';
                if (overflowY === 'auto' || overflowY === 'scroll') {
                    return node;
                }
            }
            node = node.parentElement;
        }
        return boundaryElement;
    }

    scrollLegalTargetIntoView = (container, targetElement) => {
        if (!container || !targetElement) {
            return;
        }
        const scrollContainer = this.findScrollableAncestor(targetElement, container) || container;
        const containerRect = scrollContainer.getBoundingClientRect ? scrollContainer.getBoundingClientRect() : null;
        const targetRect = targetElement.getBoundingClientRect ? targetElement.getBoundingClientRect() : null;
        if (containerRect && targetRect) {
            const nextScrollTop = scrollContainer.scrollTop + (targetRect.top - containerRect.top) - 8;
            scrollContainer.scrollTop = Math.max(0, nextScrollTop);
        } else {
            const nextScrollTop = (targetElement.offsetTop || 0) - 8;
            scrollContainer.scrollTop = Math.max(0, nextScrollTop);
        }
    }

    handleLegalContentClick = (index, event) => {
        let link = event.target;
        while (link && link !== event.currentTarget && link.tagName !== 'A') {
            link = link.parentNode;
        }
        if (!link || link.tagName !== 'A') {
            return;
        }
        const href = link.getAttribute('href');
        if (!href) {
            return;
        }

        const hashIndex = href.indexOf('#');
        const hash = hashIndex === -1 ? '' : this.normalizeLegalHash(href.substring(hashIndex + 1));
        const isHashLink = href.charAt(0) === '#';
        const isExternalLink = /^https?:\/\//.test(href);

        if (!isHashLink && !hash) {
            if (isExternalLink) {
                event.preventDefault();
                window.open(href, '_blank');
            }
            return;
        }

        event.preventDefault();
        if (hash) {
            this.updateLegalHashInUrl(hash);
        }
        const legalContainer = event.currentTarget || this.legalTextRefs[index];
        const targetElement = this.findLegalAnchorTarget(legalContainer, hash);
        if (targetElement) {
            this.scrollLegalTargetIntoView(legalContainer, targetElement);
            return;
        }
        if (!isHashLink) {
            window.open(href, '_blank');
        }
    }

    getUserConsentsElements = () => {
        const { t } = this.props;
        const customerCareUrl = this.getCustomerCareUrl();
        const tosBlockRenderer = (props) => {
            const {style = 'normal', markDefs= []} = props.node
            if (style === 'normal' && markDefs){
                const linkMarkDef = this.getLegalLinkMarkDef(props.node);
                if (linkMarkDef && !linkMarkDef.href && props.node.children[0] && props.node.children[0].text) {
                    linkMarkDef.href = '#' + props.node.children[0].text;
                }
            }
            const headingId = this.getLegalHeadingId(props.node);
            const blockId = this.getLegalBlockId(props.node);
            if (blockId && ['normal', 'h1', 'h2', 'h3', 'h4'].indexOf(style) !== -1) {
                const BlockTag = style === 'normal' ? 'p' : style;
                return <BlockTag id={blockId}>{props.children}</BlockTag>
            }
            if (headingId) {
                const HeadingTag = style;
                return <HeadingTag id={headingId}>{props.children}</HeadingTag>
            }
            return BlockContent.defaultSerializers.types.block(props)
        }
        const consentAccordionTypes = [TOS_CONSENT_TYPE, PRIVACY_CONSENT_TYPE, DATA_NOTICE, SENSITIVE_DATA_CONSENT_TYPE];

        var userConsentsElems = [];
        for (var i = 0; i < this.state.userConsents.length; i++) {
            var userConsent = this.state.userConsents[i];
            var requiredTextClass = classnames({
                'consent-check-required-text': true,
                'visible': userConsent.isMissingCheck
            });
            var requiredIconClass = classnames({
                'consent-check-required-icon': true,
                'visible': userConsent.isMissingCheck
            });
            if (userConsent.type === AGE_CONSENT_TYPE) { // Age consent is a special case
                var yearOptions = [];
                var year = moment().year();
                while (year >= 1900) {
                    yearOptions.push(<option key={year} value={(year)}>{year--}</option>);
                }
                var monthOptions = [];
                monthOptions.push(<option key="0" value="0">{t(['date:month.JANUARY.short', '1'])}</option>);
                monthOptions.push(<option key="1" value="1">{t(['date:month.FEBRUARY.short', '2'])}</option>);
                monthOptions.push(<option key="2" value="2">{t(['date:month.MARCH.short', '3'])}</option>);
                monthOptions.push(<option key="3" value="3">{t(['date:month.APRIL.short', '4'])}</option>);
                monthOptions.push(<option key="4" value="4">{t(['date:month.MAY.short', '5'])}</option>);
                monthOptions.push(<option key="5" value="5">{t(['date:month.JUNE.short', '6'])}</option>);
                monthOptions.push(<option key="6" value="6">{t(['date:month.JULY.short', '7'])}</option>);
                monthOptions.push(<option key="7" value="7">{t(['date:month.AUGUST.short', '8'])}</option>);
                monthOptions.push(<option key="8" value="8">{t(['date:month.SEPTEMBER.short', '9'])}</option>);
                monthOptions.push(<option key="9" value="9">{t(['date:month.OCTOBER.short', '10'])}</option>);
                monthOptions.push(<option key="10" value="10">{t(['date:month.NOVEMBER.short', '11'])}</option>);
                monthOptions.push(<option key="11" value="11">{t(['date:month.DECEMBER.short', '12'])}</option>);
                var dayOptions = [];
                var month = this.state.ageMonth;
                var daysInMonth = 31;
                if (month) {
                    var year = this.state.ageYear;
                    if (year) {
                        daysInMonth = moment().set('month', month).set('year', year).daysInMonth();
                    } else {
                        daysInMonth = moment().set('month', month).daysInMonth();
                    }
                    if (this.state.ageDay && this.state.ageDay > daysInMonth) {
                        this.setState({ ageDay: null });
                    }
                }
                for (var dayNumber = 1; dayNumber <= daysInMonth; dayNumber++) {
                    dayOptions.push(<option key={dayNumber} value={dayNumber}>{dayNumber}</option>);
                }

                var requiredTextClass = classnames({ 'consent-check-required-text': true, 'visible': userConsent.isMissingGuardianCheckIcon });
                var guardianCheckClasses = classnames({ 'consent-description': true, 'hidden': !userConsent.isMissingGuardianCheck });
                var ageSelectIconClasses = classnames({ 'consent-check-required-icon': true, 'visible': userConsent.isMissingAgeSelect });
                var guardianCheckIconClasses = classnames({ 'consent-check-required-icon': true, 'visible': userConsent.isMissingGuardianCheckIcon });
                userConsentsElems.push(<div className={classnames('consent-container', {'sensitive-consent-container': userConsent.type === SENSITIVE_DATA_CONSENT_TYPE})} key={i} id={"consentType_" + userConsent.type}>
                    <div className="consent-title-row">
                        <span>
                            {t(['gdpr:consents.popup.dob_needed', 'You have to enter your date of birth to continue using Polar Flow'])}
                        </span>
                        <span className={requiredTextClass}>
                            {t(['gdpr:consents.popup.box_unchecked', 'You need to check this box to continue'])}
                        </span>
                    </div>
                    <div className="consent-description">
                        <div className="consent-description-main-row">
                            <span className="">
                            {t(['date:birthday', 'Day of birth'])}
                            </span>
                            <Select placeholder={t(['date:day', 'Day'])} value={this.state.ageDay} onChange={(day) => this.ageValueChanged(day, this.state.ageMonth, this.state.ageYear)}>
                                {dayOptions}
                            </Select>
                            <Select placeholder={t(['reports:chart.month', 'Month'])} value={this.state.ageMonth} onChange={(month) => this.ageValueChanged(this.state.ageDay, month, this.state.ageYear)}>
                                {monthOptions}
                            </Select>
                            <Select placeholder={t(['date:year', 'Year'])} value={this.state.ageYear} onChange={(year) => this.ageValueChanged(this.state.ageDay, this.state.ageMonth, year)}>
                                {yearOptions}
                            </Select>
                            <span className="consent-select-age">
                                <span className={ageSelectIconClasses} />
                            </span>
                        </div>
                    </div>
                    <div className={guardianCheckClasses}>
                        <div className="consent-description-main-row">
                            <div>
                                {t(['gdpr:consents.popup.guardian_consent.title', 'Guardian\'s consent'])}
                            </div>
                            <span className="consent-short-description">
                                {t(['gdpr:consents.popup.guardian_consent.text', 'As guardian, I give Polar permission to collect and process personal data of the young person in question as described in the Polar Privacy Notice'])}
                            </span>
                            <span className="consent-check">
                                <span className={guardianCheckIconClasses} />
                                <Checkbox onChange={this.checkboxClicked.bind(this, i)} />
                            </span>
                        </div>
                    </div>
                </div>);
            }
            else if (userConsent.contentUrl && consentAccordionTypes.indexOf(userConsent.type) !== -1) { // Accordion block
                var accordionCaretClass = classnames({
                    'icon': true,
                    'icon-arrow-up': true,
                    'caret-rotated': userConsent.isContentVisible
                });
                userConsentsElems.push(<div className={classnames('consent-container', {'sensitive-consent-container': userConsent.type === SENSITIVE_DATA_CONSENT_TYPE})} key={i} id={"consentType_" + userConsent.type}>
                    <div className="consent-title-row">
                        <span>
                            {t([userConsent.name, '' + userConsent.name])}
                            {userConsent.required && '*'}
                        </span>
                        <span className={requiredTextClass}>
                            {t(['gdpr:consents.popup.box_unchecked', 'You need to check this box to continue'])}
                        </span>
                    </div>
                    <div className="consent-description">
                        <div className="consent-description-main-row">
                            <span className={"consent-short-description"} onClick={this.flipContentVisibility.bind(this, i)}>
                                <a>{t([userConsent.description, '' + userConsent.description])}</a>
                                <i className={accordionCaretClass} />
                            </span>
                            <span className="consent-check">
                                <span className={requiredIconClass} />
                                <Checkbox onChange={this.checkboxClicked.bind(this, i)} />
                            </span>
                        </div>
                            {userConsent.isLegalContentError &&
                                <div className="consent-modal-legal-document-error-row">
                                    {this.renderLegalErrorInfoWithLink(customerCareUrl)}
                                </div>
                            }
                            { userConsent.type === SENSITIVE_DATA_CONSENT_TYPE && userConsent.sensitiveConsentDataTypes &&
                                this.listSensitiveConsents(userConsent.sensitiveConsentDataTypes)
                            }
                            <div className="consent-accordion" style={{ display: userConsent.isContentVisible ? 'block' : 'none' }}>
                               { userConsent.type === TOS_CONSENT_TYPE && userConsent.content &&
                                <div className="consent-text" ref={(element) => this.setLegalTextRef(i, element)} onClick={(event) => this.handleLegalContentClick(i, event)}>
                                    <BlockContent blocks={userConsent.content} serializers={{types: {block: tosBlockRenderer}}} />
                                </div>
                               }
                               { [PRIVACY_CONSENT_TYPE, DATA_NOTICE, SENSITIVE_DATA_CONSENT_TYPE].indexOf(userConsent.type) !== -1 && userConsent.content &&
                                <div className={classnames('consent-text', {'sensitive-consent': userConsent.type === SENSITIVE_DATA_CONSENT_TYPE})} ref={(element) => this.setLegalTextRef(i, element)} onClick={(event) => this.handleLegalContentClick(i, event)}>
                                    <BlockContent blocks={userConsent.content} serializers={{types: {block: this.renderLegalBlock}}} />
                                </div>
                               }
                            </div>
                    </div>
                </div>);    
            } else { // Simple block without accordion
                userConsentsElems.push(<div className="consent-container" key={i} id={"consentType_" + userConsent.type}>
                    <div className="consent-title-row">
                        <span>
                            {t([userConsent.name, '' + userConsent.name])}
                            {userConsent.required && '*'}
                        </span>
                        <span className={requiredTextClass}>
                            {t(['gdpr:consents.popup.box_unchecked', 'You need to check this box to continue'])}
                        </span>
                    </div>
                    <div className="consent-description">
                        <div className="consent-description-main-row">
                            <span className="consent-short-description">
                                {t([userConsent.description, '' + userConsent.description])}
                            </span>
                            <span className="consent-check">
                                <span className={requiredIconClass} />
                                <Checkbox onChange={this.checkboxClicked.bind(this, i)} />
                            </span>
                        </div>
                    </div>
                </div>);
            }
        }
        return userConsentsElems;
    }

    hasLegalContentErrors = () => {
        if (!this.state.userConsents) {
            return false;
        }
        return this.state.userConsents.some((userConsent) => {
            if (!userConsent.contentUrl) {
                return false;
            }

            if (userConsent.isLegalContentError) {
                return true;
            }

            return !Array.isArray(userConsent.content) || userConsent.content.length === 0;
        });
    }

    getCustomerCareUrl = () => {
        const language = (i18n.language || 'en').split('-')[0].toLowerCase();
        return `https://support.polar.com/${language}/contact`;
    }

    translateWithFallback = (translationKey, fallbackText) => {
        const { t } = this.props;
        const translatedText = t([translationKey, fallbackText]);

        if (!translatedText || translatedText === translationKey) {
            return fallbackText;
        }

        return translatedText;
    }

    renderLegalErrorInfoWithLink = (customerCareUrl) => {
        const language = i18n.language || 'en';
        const fallbackLanguage = language.split('-')[0];
        const getResource = typeof i18n.getResource === 'function' ? i18n.getResource.bind(i18n) : null;
        const infoText = (getResource && getResource(language, 'legal_document', 'cannot_retrieve.info_with_link_to_care'))
            || (getResource && getResource(fallbackLanguage, 'legal_document', 'cannot_retrieve.info_with_link_to_care'))
            || this.translateWithFallback('legal_document:cannot_retrieve.info_with_link_to_care', 'Can\'t retrieve the document right now. If the problem persists, contact {0}.');
        const customerCareText = this.translateWithFallback('legal_document:customer_care_link_text', 'Customer care');
        const parts = infoText.split('{0}');

        if (parts.length < 2) {
            return (
                <span className="legal-document-error-text">
                    {infoText}{' '}
                    <a className="legal-document-support-link" href={customerCareUrl} target="_blank" rel="noopener noreferrer">
                        {customerCareText}
                    </a>
                </span>
            );
        }

        return (
            <span className="legal-document-error-text">
                {parts[0]}
                <a className="legal-document-support-link" href={customerCareUrl} target="_blank" rel="noopener noreferrer">
                    {customerCareText}
                </a>
                {parts.slice(1).join('{0}')}
            </span>
        );
    }

    render() {
        const { t } = this.props;
        const modalTitle = t(['gdpr:settings.missing_consent.header', 'We need your consent']);
        const isAcceptDisabled = this.hasLegalContentErrors();

        if (this.state.isConsentsAccepted || !this.state.userConsents) {
            return null;
        }
        var userConsentsElems = this.getUserConsentsElements();

        var languageCode = i18n.language;
        var langParts = languageCode.split("-");
        if (langParts.length === 2) {
            var langPart = langParts[0].toLowerCase();
            var countryPart = langParts[1].toLowerCase();
            languageCode = countryPart+"-"+langPart;
        }
        return (
            <Modal show bsClass="consent-modal">
                <Modal.Header>
                    <Modal.Title className="consent-modal-title">
                        {modalTitle}
                    </Modal.Title>
                    <a id="consent-modal-info-link" target="_blank" rel="noopener noreferrer"  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMiAyMiI+PHRpdGxlPmluZm8taWNvbjwvdGl0bGU+PHBhdGggZD0iTTEwLjEyNSwxNi4yOVYxMS4ybC0xLjQzNS4wMzFWOS4zNTVoMy42M1YxNi4yOWgtMi4yWk0xMi40MTcsNi4yMDdhMS41LDEuNSwwLDEsMS0xLjUtMS41QTEuNSwxLjUsMCwwLDEsMTIuNDE3LDYuMjA3WiIgZmlsbD0iIzAwOWJlMCIvPjxwYXRoIGQ9Ik0xMSwxQTEwLDEwLDAsMSwwLDIxLDExLDEwLDEwLDAsMCwwLDExLDFabTAsMTguNUE4LjUsOC41LDAsMSwxLDE5LjUsMTEsOC41LDguNSwwLDAsMSwxMSwxOS41WiIgZmlsbD0iIzAwOWJlMCIvPjwvc3ZnPg==);" href={"https://www.polar.com/{{LANG}}/legal/faq".replace("{{LANG}}", languageCode)}></a>
                </Modal.Header>
                <Modal.Body>
                    <div className="consents-body">
                        <div className="consents-information">
                            {t(['gdpr:consents.popup.general_info1', 'Polar Flow is all about your training and hard work — moreover, your data. That’s why we ask you to go through these settings about your rights to your data, the privacy of your data, and how you allow us to handle your data. Polar does not disclose, give or sell your data to anyone. Your data will not be shared to third parties.'])}
                            <div className='consents-information-second-info'>
                            {t(['gdpr:consents.popup.general_info2', 'As we collect and process your data at Polar, we are bound by data protection regulations. This is why we need your explicit consent to handle your data.'])}
                            <a href={"https://www.polar.com/{LANG}/legal/faq".replace("{LANG}", languageCode)} target="_blank"> {t(['common:learn_more', 'Learn more'])}</a>
                            </div>
                        </div>
                        {userConsentsElems}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <a id="no-thanks-logout" href={this.state.ssoEnabled ? "/flowSso/logout" : "/logout"}>
                        {t(['gdpr:consents.popup.no_thanks_button', 'No thanks, sign out'])}
                    </a>
                    {(this.state.isConsentsAccepted === false) &&
                        <span className="consent-button-click-required">
                            {t(['gdpr:consents.popup.consent_needed', 'We still need your consent'])}
                        </span>
                    }
                    {isAcceptDisabled &&
                        <span className="consent-button-click-required">
                            {this.translateWithFallback('legal_document:cannot_retrieve.try_again_prompt', 'Please try again later.')}
                        </span>
                    }
                    <button type="button" className={classnames('accept-button', { disabled: isAcceptDisabled })} onClick={this.consentsAcceptClick} disabled={isAcceptDisabled}>
                        {t(['common:accept', 'Accept'])}
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}
const wrapped = translate(['common', 'gdpr', 'legal_document'], { wait: true })(ConsentModal);
export { ConsentModal, wrapped as default };



// WEBPACK FOOTER //
// ./src/ConsentsLoginModal/index.jsx